import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../services/task.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {TaskDTO} from '../../../model/taskDTO';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  animations: [
    trigger('items', [
      transition(':enter', [
        style({opacity: 0}),
        animate('600ms ease-out', style({opacity: 1})
        ),
      ])
    ])
  ],
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements OnInit {

  @Input() level: TaskDTO.LevelEnum;
  @Input() clientId;

  tasks: TaskDTO[] = [];
  closed = true;
  limit = 7;
  currentYear = new Date().getFullYear();
  nextYear = new Date().getFullYear() + 1;

  constructor(private service: TaskService) {
  }

  ngOnInit() {
    this.service.getAll(this.clientId, this.level).subscribe(response => this.tasks = response);
  }
}
